<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column pa-1">

    <div class="layout-column lx-panel-content elevation-2 mb-1" style="border-radius: 6px;"
         :style="{'background': compColor.lxExpansion.background}">
      <div class="layout-row pa-1">
        <div class="flex blue-grey--text layout-row"
             :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5  text--darken-1' : 'transparent  text--lighten-2']"
             style="border-radius: 3px;"
             :style="{'border': compColor.isInDarkMode ? '1px solid ' + compColor.primeColor + ' !important' : '1px solid transparent'}">


          <div class="layout-column layout-align-center-center pa-1">
            <div class="pa-2" style="border-radius: 4px;" :class="compColor.prime">
              <v-icon size="30" color="white" v-if="patient.gender === 'W'">mdi-gender-female</v-icon>
              <v-icon size="30" color="white" v-if="patient.gender === 'M'">mdi-gender-male</v-icon>
              <v-icon size="30" color="white" v-if="patient.gender === 'U'">mdi-gender-male-female-variant</v-icon>
              <v-icon size="30" color="white" v-if="patient.gender === 'D'">mdi-gender-transgender</v-icon>
              <v-icon size="30" color="white" v-if="patient.gender === 'X'">mdi-gender-non-binary</v-icon>
            </div>
          </div>

          <div class="layout-column px-3 py-0 layout-align-center-start">
            <div class="layout-row">
              <span class="mr-4 font-weight-bold text-h6"
                    style="line-height: 20px;">{{ patient.lastname }}, {{ patient.firstname }}</span>
            </div>

            <v-divider class="my-1" style="width: 100%;"></v-divider>

            <div class="body-2 layout-row">
              <div>
                <v-icon size="13" :color="compColor.prime">mdi-cake-variant</v-icon>
                <span class="ml-1" style="border-radius:3px;line-height:14px;display: inline-block;">{{ patient.birthday }}</span>
              </div>

              <v-divider vertical v-if="!!dateOfDeath" class="mx-2"></v-divider>

              <div v-if="!!dateOfDeath">
                <v-icon size="13" :color="compColor.prime">mdi-christianity</v-icon>
                <span class="ml-1" style="border-radius:3px;line-height:14px;display: inline-block;">{{ dateOfDeath }}</span>
              </div>

            </div>
          </div>

          <v-divider vertical></v-divider>

          <div class="layout-column px-3 py-0 layout-align-center-start">
            <div class="body-2 layout-row">
              <v-icon size="13" :color="compColor.prime">mdi-clipboard-edit</v-icon>
              <span class="ml-2"
                    style="min-width:90px;line-height:23px;display: inline-block;">{{ patient.lastModified }}</span>
              <small style="opacity:0.5;line-height:23px;min-width: 40px;display: inline-block;">(zuletzt bearb.)</small>
            </div>

            <div class="body-2 layout-row">
              <v-icon size="13" :color="compColor.prime">mdi-id-card</v-icon>
              <span class="ml-2"
                    style="min-width:90px;line-height:23px;display: inline-block;">{{ patient.ais_id }}</span>
              <small style="opacity:0.5;line-height:23px;min-width: 40px;display: inline-block;">(ID Arztsoftware)</small>
            </div>
          </div>

          <div class="flex"></div>
          <div class="layout-column layout-align-center px-2">
            <v-btn :dark="compColor.isInDarkMode" class="white--text text-none ml-5 px-4"
                   :color="compColor.primeColor"
                   dense
                   @click="showIt=false" depressed>
              <v-icon color="white" left>mdi-account-reactivate</v-icon>
              Stammdaten bearbeiten
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <div class="flex layout-column">
      <diagnoses-list v-if="!showDocumentation" :patientId="patientId" :tabid="tabid" :canEdit="true"
                      style="border: 1px solid rgba(0,0,0,0.1);border-radius: 5px;"
                      @input="openDocumentation"></diagnoses-list>
      <documentation v-if="showDocumentation" :selectedFormData="selectedFormData" :tabid="tabid"
                     @click="showDocumentation=false"></documentation>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import metaData from '../../components/documentation/shared/formsMetaData'
import utils from '../../common/utils'
import diagnosesList from './DiagnosesList'
import documentation from './Documentation'

export default {
  name: 'PatientDiagnoses',
  props: ['patientId', 'tabid', 'value'],
  mixins: [metaData, utils],
  components: {
    diagnosesList,
    documentation
  },
  data () {
    return {
      panel: [0],
      loading: false,
      showIt: true,
      showDocumentation: false,
      selectedFormData: {},
      titleValues: null,
      patient: {},
      dateOfDeath: null
    }
  },
  created () {
    this.$eventBus.on('updatePatientDetail', this.getPatientData, this.$route?.params?.tabid)
    this.$eventBus.on('reload-after-form-update-' + this.patientId, this.reloadPatientAfterFormUpdate, this.$route?.params?.tabid)

    this.titleValues = this.formsMetaData.titleValues
  },
  destroyed () {
    this.$eventBus.remove('updatePatientDetail', this.$route?.params?.tabid)
    this.$eventBus.remove('reload-after-form-update-' + this.patientId, this.$route?.params?.tabid)
  },
  methods: {
    /**
     * Reload patient after updating form, when last_modified on patient is older than actually date
     */
    reloadPatientAfterFormUpdate () {
      // reload if last_modified on patient is in the past
      if (moment().isAfter(moment(this.patient.lastModified, 'DD.MM.YYYY'), 'day')) {
        this.getPatientData()
      }
    },

    /**
     * Get existing patient from db
     */
    getPatientData () {
      if (this.loading) return
      this.loading = true

      this.$http.get('/patients/' + this.patientId) // get auth user data
        .then(resultPatient => {
          if (resultPatient.data) {
            this.dateOfDeath = resultPatient.data.dateOfDeath ? moment(resultPatient.data.dateOfDeath).format('DD.MM.YYYY') : null
            this.patient = resultPatient.data.patient
            this.patient.birthday = moment(this.patient.birthday).format('DD.MM.YYYY')
            this.patient.lastModified = moment(this.patient.lastModified).format('DD.MM.YYYY')

            // copy ais-id from patient to clipboard
            if (this.patient.ais_id) {
              const id = this.patient.ais_id
              // create textarea with text content to copy to clipboard
              let textArea = document.createElement('textarea')
              textArea.value = id
              document.body.appendChild(textArea)
              textArea.select()
              document.execCommand('copy')
              textArea.remove()
            }

            // route to selected invalid form from report dialog, form is not death-form
            const storedPatient = this.$store.getters.routingAfterReportValidation(this.patientId)

            if (storedPatient && storedPatient.showFormData && storedPatient.formDetails && storedPatient.formDetails.key !== 'death') {
              const baseData = {
                diagCode: storedPatient.formDetails.diagCode,
                diagDate: storedPatient.formDetails.diagDate,
                subjId: storedPatient.formDetails.subj_id,
                localization: storedPatient.formDetails.localization,
                patientId: this.patientId,
                registerId: storedPatient.formDetails.registerId
              }

              if (this.dateOfDeath) {
                baseData.deathDate = this.dateOfDeath
              }

              this.$store.dispatch('setDiagnosisBaseInformation', baseData)
              this.$store.dispatch('setActualSubjID', { patient: this.patientId, subjId: storedPatient.formDetails.subj_id })
              this.openDocumentation({ form: { _id: storedPatient.formDetails.id }, key: storedPatient.formDetails.key, baseData: baseData })
            } else if (storedPatient && storedPatient.showFormData && storedPatient.formDetails && storedPatient.formDetails.key === 'death') {
              // change view to diagnoses list, if tab of patient is already opened with view of forms
              this.showDocumentation = false
            }
          }
        })
        .catch(() => {
          this.removeTabFromStoreByTabid(this.tabid || this.$route?.params?.tabid)
        })
        .finally(() => {
          this.loading = false
        })
    },

    /**
     * Open view of form documentation after clicking item in diagnoses list
     *
     * @param form
     */
    openDocumentation (form) {
      this.selectedFormData = form
      this.showDocumentation = true
    }
  },
  watch: {
    showIt: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.showIt = newValue
        }
      },
      immediate: true
    },
    '$route': {
      handler: function (to) {
        if (to?.path === '/patient/details/' + this.tabid + '/' + this.patientId) {
          // refresh data or load initial if switching to patient details
          this.getPatientData()
        }
      },
      immediate: true
    }
  }
}
</script>
